
import { useSelector, useDispatch } from "react-redux"
import styled from "styled-components"
import { addPaketlemeDimensionItem, addPaketlemeItem, setPaketlemePermissonData, updatePaketlemeItem } from "../../../../features/addLoad/addLoadSlice"
import { handleActiveSelect } from "../../../../features/layout/layoutSlice"

import { PaketlemeTypeSvg } from "./PaketlemeTypes"
import PaketlemeDimension from "./PaketlemeDimension"
import {HiPlus} from "react-icons/hi"
import paketlemeItemDimensions from "../../../../utils/yukOptions/paketlemeItemDimension"
import { v4 as uuidv4 } from 'uuid';
import { showModal } from "../../../../features/modal/modalSlice"

const Container = styled.div`
    display: flex;
    width: 600px;
    flex-direction: column;
    gap: 15px;

    .selected-paketleme-type-item{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin: 20px 0;


        .paketleme-type-title{
            width: 100%;
            border-bottom: 1px solid ${({theme}) => theme.mainTextColor};
            padding-bottom: 2px;
            display: flex;
            justify-content: space-between;

            h4{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-xl);
            }

            .delete-btn{
                padding: 4px 14px;
                border-radius: 5px;
                background-color: ${({theme}) => theme.secondaryBgColor};
                font-size: var(--font-size-sm);
                font-size: 12px;
                font-weight: var(--font-weight-lg);
                cursor: pointer;

                &:hover{
                    background-color: ${({theme}) => theme.mainTextColor};
                    color: ${({theme}) => theme.mainBgColor};
                }
            }
        }

        .paketleme-type-list{
            display: flex;
            gap: 15px;

            .paketleme-type-item{
                width: 70px;
                height: 60px;
                border-radius: 5px;
                background-color: ${({theme}) => theme.secondaryBgColor};
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: center;
                padding: 5px;
                gap: 4px;
                cursor: pointer;
                position: relative !important;

                .paketleme-name{
                    color: ${({theme}) => theme.mainTextColor};
                    font-size: 10px;
                    font-weight: var(--font-weight-sm)
                }

                .paketleme-name-active{
                    color: var(--color-main);
                }
            }

            .paketleme-type-item-other-container{
                width: 70px;
                height: 60px;
                border-radius: 5px;
                background-color: ${({theme}) => theme.secondaryBgColor};
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: center;
                padding: 5px;
                gap: 4px;
                cursor: pointer;
                position: relative;
                border-bottom: 4px solid var(--color-main);

                .paketleme-name{
                    color: ${({theme}) => theme.mainTextColor};
                    font-size: 10px;
                    font-weight: var(--font-weight-sm)
                }

                .paketleme-type-other-list{
                    position: absolute;
                    top: 70px;
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    z-index: 20;
                    background-color: ${({theme}) => theme.mainBgColor};

                    .paketleme-type-other-item{
                        width: 70px;
                        height: 60px;
                        border-radius: 5px;
                        background-color: ${({theme}) => theme.secondaryBgColor};
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-end;
                        align-items: center;
                        padding: 5px;
                        gap: 4px;
                        cursor: pointer;

                        .paketleme-other-item-name{
                            color: ${({theme}) => theme.mainTextColor};
                            font-size: 10px;
                             font-weight: var(--font-weight-sm)
                        }

                        .paketleme-other-item-name-active{
                            color: var(--color-main);
                        }
                    }
                }
            }
        }

        .plus-dimension-icon-wrapper{
            padding: 10px;
            padding-left: 0;
            margin-left: 15px;
            cursor: pointer;
            display: flex;
            align-items: center;
            font-weight: var(--font-weight-lg);
            font-size: var(--font-size-sm);

            .plus-dimension-icon{
                font-size: 2rem;
            }
        }

        .input-wrapper{
            margin-left: 20px;
        }
    }

    .paketleme-turu-ekle-btn{
        margin: 20px 0;
        display: flex;
        align-items: center;
        gap: 10px;
        background-color: transparent;

        .paketleme-type-plus-icon{
            font-size: 2.5rem;
        }

        span{
            font-weight: var(--font-weight-xl);
            font-size: var(--font-size-sm);
        }
    }
`

const PaketlemeTypesSection = () => {

    const {paketlemeTypes, paketlemeData } = useSelector(state => state.addLoad)
    const {activeSelect, theme} = useSelector(state => state.layout)

    const dispatch = useDispatch()


    const handleAddPaketlemeItemDimension = (paketlemeDataItem) => {
        const dimensions = paketlemeItemDimensions.find(item => item.id === paketlemeDataItem.activePaketlemeTypeId).dimensions

        dispatch(addPaketlemeDimensionItem({id: paketlemeDataItem.id, dimensions}))
    }

    const handleUpdatePaketlemeItem = (paketlemeData, paketlemeItem) => {
        //! paketlemeData (aktif olan paketleme)
        //! paketlemeItem (tıklanan paketleme tipi)

        const dimensions = paketlemeItemDimensions.find(item  => item.id ===paketlemeItem.id).dimensions
        const list = [{...dimensions, id: uuidv4()}]
        dispatch(updatePaketlemeItem({id: paketlemeData?.id, list, paketlemeType: paketlemeItem.name,  activePaketlemeTypeId: paketlemeItem.id, ustUsteYuklenmesin: false, ustUsteMiktar: 0,}))
    }
    
    
  return (
    <Container>
        {
            paketlemeData?.map((paketlemeDataItem, i) => (
                <div className="selected-paketleme-type-item" key={i}>
                    <div className="paketleme-type-title">
                        <h4>Paketleme Türü {paketlemeData?.length > 1 && i + 1 } ({paketlemeDataItem?.paketlemeType})</h4>
                        {
                            paketlemeData?.length > 1 &&
                            <button className="delete-btn" onClick={() => {dispatch(setPaketlemePermissonData(paketlemeDataItem)); dispatch(showModal("deleteLoadPaketlemeItemPermission"))}}>Sil</button>
                        }
                    </div>
                    <div className="paketleme-type-list">
                        {
                            paketlemeTypes?.filter((item) => {
                                return !item?.isOther
                            })?.map((item , i) => (
                                <div className="paketleme-type-item" onClick={() => handleUpdatePaketlemeItem(paketlemeDataItem, item)} key={i}>
                                    <PaketlemeTypeSvg id={item?.id} color={item?.id === paketlemeDataItem?.activePaketlemeTypeId ? "#E85446": theme === "dark" ? "#D4D4D4": "#3C3C3B"}/>
                                    <div className={item?.id === paketlemeDataItem?.activePaketlemeTypeId ? "paketleme-name paketleme-name-active" : "paketleme-name"}>{item?.name}</div>
                                </div>
                            ))
                        }

                        {/* //! bu diger olanlar */}
                        <div className="paketleme-type-item-other-container" onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === "paketlemeTypes") ? null : "paketlemeTypes"+i))}>
                            <PaketlemeTypeSvg id={(paketlemeDataItem?.activePaketlemeTypeId === 1 || paketlemeDataItem?.activePaketlemeTypeId === 2 || paketlemeDataItem?.activePaketlemeTypeId === 3 || paketlemeDataItem?.activePaketlemeTypeId === 4 )? 0 : paketlemeDataItem?.activePaketlemeTypeId } color={theme === "dark" ? "#D4D4D4": "#3C3C3B"}/>
                            <div className={"paketleme-name"}>{(paketlemeDataItem?.activePaketlemeTypeId === 1 || paketlemeDataItem?.activePaketlemeTypeId === 2 || paketlemeDataItem?.activePaketlemeTypeId === 3 || paketlemeDataItem?.activePaketlemeTypeId === 4 )? "Diğer" : paketlemeDataItem.paketlemeType}</div>
                            {
                                (activeSelect === "paketlemeTypes"+i) &&
                                <div className="paketleme-type-other-list">
                                    {
                                        paketlemeTypes?.filter((item) => {
                                            return item?.isOther
                                        })?.map((item , i) => (
                                            <div className="paketleme-type-other-item" onClick={() => handleUpdatePaketlemeItem(paketlemeDataItem, item)} key={i}>
                                                <PaketlemeTypeSvg id={item?.id} color={item?.id === paketlemeDataItem?.activePaketlemeTypeId ? "#E85446": theme === "dark" ? "#D4D4D4": "#3C3C3B"}/>
                                                <div className={item?.id === paketlemeDataItem?.activePaketlemeTypeId ? "paketleme-other-item-name paketleme-other-item-name-active" : "paketleme-other-item-name"}>{item?.name}</div>
                                            </div>
                                        ))
                                    }
                                </div>
                            }
                        </div>
                    </div> 
                            <PaketlemeDimension dimension={paketlemeDataItem.list} typeId={paketlemeDataItem.activePaketlemeTypeId} paketlemeDataItemId={paketlemeDataItem.id}/>
                            <div className="plus-dimension-icon-wrapper" onClick={()=> handleAddPaketlemeItemDimension(paketlemeDataItem)}>
                                <HiPlus className="plus-dimension-icon"/> Farklı Ölçülerde {paketlemeDataItem.paketlemeType} ekle
                            </div>
                </div>
            ))
        }
        <button className="paketleme-turu-ekle-btn" onClick={()=> dispatch(addPaketlemeItem())}>
            <HiPlus className="paketleme-type-plus-icon"/>
            <span>{paketlemeData.length >= 1 && `${paketlemeData.length+1}.`}Paketleme Türü Ekle</span>
        </button>
    </Container>
  )
}

export default PaketlemeTypesSection